var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.getThemeTag.title),expression:"getThemeTag.title"}],staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('keep-alive',[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }